export const ALLOWED_DRAFTS_AI_SEARCH_STATUS = [
    'active',
    'scheduled',
    'archived'
];
export const CREDIT_CARD_FEES_PAID_BY = [
    'client',
    'service_provider'
];
export const ALLOWED_BILLED_UPON = [
    'ongoing',
    'oneTimeManual',
    'approval',
    'repeatableManual',
    'oneTimeDelivery',
    'oneTimeInStages',
    'onDemand'
];
export const ALLOWED_RECURRENCE = [
    'weekly',
    'biweekly',
    'monthly',
    'quarterly',
    'yearly'
];
export const ALLOWED_PRICING_TYPE = [
    'fixed',
    'variable',
    'range'
];
export const ALLOWED_DISCOUNT_TYPE = [
    'none',
    'value',
    'percent'
];
export const ALLOWED_START_ON_TYPE = [
    'yearly',
    'yearlyEffectiveDate'
];
export const SERVICE_QUANTIFIERS = [
    'any',
    'all',
    'none'
];
export const EFFECTIVE_DATE_MODES = [
    'onAcceptance',
    'specificDate'
];
